import axiosInstance from "../axiosInstance";

const CONTROLLER = "suggesteds";

const get_laboratory_suggestions = async (search) => {
	const response = await axiosInstance.get(
		`${CONTROLLER}?search=${search || ""}`,
	);
	return response.data;
};

const get_laboratory_suggestions_page = async (search, state, page) => {
	const response = await axiosInstance.get(
		`${CONTROLLER}/GetPage?search=${
			search || ""
		}&state=${state}&pageNumber=${page}`,
	);
	return response.data;
};

const get_laboratory_suggestion_by_id = async (id) => {
	const response = await axiosInstance.get(`${CONTROLLER}/GetById/${id}`);
	return response.data;
};

const get_laboratory_suggestion_header_info = async (search) => {
	const response = await axiosInstance.get(
		`${CONTROLLER}/GetLaboratorySuggestionsHeader?search=${search || ""}`,
	);
	return response.data;
};

const create_laboratory_suggestion = async (payload) => {
	const response = await axiosInstance.post(`${CONTROLLER}`, payload);
	return response.data;
};

const update_laboratory_suggestion = async (id, payload) => {
	const response = await axiosInstance.put(`${CONTROLLER}/${id}`, payload);
	return response.data;
};

const update_laboratory_suggestion_state = async (id, state) => {
	const response = await axiosInstance.put(
		`${CONTROLLER}/UpdateLaboratorySuggestionState/${id}`,
		state,
	);
	return response.data;
};

const get_laboratory_suggested_products = async (id, filters) => {
	const response = await axiosInstance.get(
		`${CONTROLLER}/GetLaboratorySuggestedProducts/${id}`,
		{
			params: filters,
		},
	);
	return response.data;
};

const update_suggested_product_state = async (payload) => {
	const response = await axiosInstance.put(
		`${CONTROLLER}/UpdateSuggestedProductState`,
		payload,
	);
	return response.data;
};

const run_MCDA_algoritm = async (payload) => {
	const response = await axiosInstance.post(
		`${CONTROLLER}/runAlgoritm`,
		payload,
	);
	return response.data;
};

const get_laboratory_pdv_pool = async (
	laboratoryId,
	userRouteId,
	inAgentPool,
) => {
	const params = {
		laboratoryId: laboratoryId || "",
		userRouteId: userRouteId || "",
	};

	if (typeof inAgentPool === "boolean") params.inAgentPool = inAgentPool;

	const response = await axiosInstance.get(`${CONTROLLER}/GetAgentPool`, {
		params,
	});
	return response.data;
};

const save_laboratory_pdv_pool = async ({
	laboratoryId,
	laboratoryRouteIds,
	inAgentPool,
}) => {
	return axiosInstance.post(`${CONTROLLER}/SaveAgentPool`, {
		laboratoryId,
		items: laboratoryRouteIds.map((id) => ({
			laboratoryRouteId: id,
			inAgentPool,
		})),
	});
};

const get_points_of_sale_suggested = async (
	laboratoryId,
	qtySuggested,
	posId,
) => {
	const params = {
		laboratoryId: laboratoryId,
		qtySuggested: qtySuggested,
		posId: posId,
	};

	const response = await axiosInstance.get(`${CONTROLLER}/GetPdvSuggesteds`, {
		params,
	});
	return response.data;
};

export {
	get_laboratory_suggestions,
	get_laboratory_suggestions_page,
	create_laboratory_suggestion,
	get_laboratory_suggestion_by_id,
	update_laboratory_suggestion,
	get_laboratory_suggestion_header_info,
	update_laboratory_suggestion_state,
	get_laboratory_suggested_products,
	update_suggested_product_state,
	run_MCDA_algoritm,
	get_laboratory_pdv_pool,
	save_laboratory_pdv_pool,
	get_points_of_sale_suggested,
};
